import {
  InstitutionProgram,
  ProgramDecision,
} from "../../../../../common/api/decimal/methods/course.ts";
import { FormattedMessage } from "react-intl";
import Toast from "../../../../../common/core-ui/Toast.tsx";
import { MyCoursesConfig } from "../../layout/myCoursesLayoutLoader.ts";
import { ReactNode } from "react";
import { SingleSpaceLiteral } from "common/core-ui/SingleSpaceLiteral.tsx";

interface ToastProps {
  institutionProgram: InstitutionProgram;
  oldProgram: ProgramDecision;
  newProgram: ProgramDecision;
  materialCount: number;
  onClose?: () => void;
  config: MyCoursesConfig;
  toastBody?: ReactNode;
}

export default function ProgramChangeSuccessToast({
  institutionProgram,
  oldProgram,
  newProgram,
  materialCount,
  onClose,
  config,
}: ToastProps) {
  function getHeading() {
    const programName =
      institutionProgram === "equitable_access"
        ? config.equitable_access?.programName
        : config[newProgram]?.programName ?? "";

    if (institutionProgram === "equitable_access") {
      if (newProgram === "no_program") {
        return (
          <FormattedMessage
            defaultMessage="You have opted out of {programName} and lost access to {materialCount, plural, =1 {1 required course material} other {# required course materials}}."
            values={{
              programName,
              materialCount,
            }}
          />
        );
      }
      return (
        <FormattedMessage
          defaultMessage="You have opted in to {programName} and gained access to {materialCount, plural, =1 {1 required course material} other {# required course materials}}."
          values={{
            programName,
            materialCount,
          }}
        />
      );
    }

    if (newProgram === "no_program") {
      return (
        <FormattedMessage
          defaultMessage="You have opted out of all course material programs and lost access to {materialCount, plural, =1 {1 course material} other {# course materials}}."
          values={{ materialCount }}
        />
      );
    }

    if (oldProgram === "no_program") {
      return (
        <FormattedMessage
          defaultMessage="You have gained access to {materialCount, plural, =1 {1 course material} other {# course materials}} in {programName}."
          values={{ programName, materialCount }}
        />
      );
    }

    return (
      <FormattedMessage
        defaultMessage="You switched to {programName}."
        values={{
          programName,
        }}
      />
    );
  }

  function getBody() {
    const base = (
      <FormattedMessage defaultMessage="Billing will be updated in your student account." />
    );
    if (
      institutionProgram === "equitable_access" &&
      newProgram === "no_program"
    ) {
      return (
        <span>
          {base}
          <SingleSpaceLiteral />
          <FormattedMessage defaultMessage="Check your student email for refund information." />
        </span>
      );
    }

    return <>{base}</>;
  }

  return (
    <Toast onClose={onClose} type="success" title={getHeading()}>
      {getBody()}
    </Toast>
  );
}
